module.exports = __webpack_public_path__ + "img/all-a.de6140ff.png";